import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-project-inner',
  templateUrl: './project-inner.component.html',
  styleUrls: ['./project-inner.component.scss']
})
export class ProjectInnerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
